(() => {
  const popupTitle = 'Welcome to LolitaFetch';
  const popupCopy = 'Subscribe for new arrivals, designer discoveries and styling inspiration.';
    const popupWidgetCopy = 'GET 10% OFF';
  const popupRootSelector = '.react-responsive-modal-root:has(.pp-modal)';
  const popupCloseSelector = '.pp-modal .ecomsend__Modal__CloseButton';
  const isHomepage = document.body.classList.contains('template-index');
  let updateQueued = false;
  let popupEligible = false;

  const releasePageScroll = () => {
    if (document.body.classList.contains('lfm-cart-open')) return;
    document.documentElement.style.removeProperty('overflow');
    document.body.style.removeProperty('overflow');
  };

  const revealDeferredPopup = () => {
    if (popupEligible) return;
    popupEligible = true;
    window.removeEventListener('scroll', revealAfterIntent);

    if (document.body.classList.contains('lfm-cart-open')) return;

    document.querySelectorAll(`${popupRootSelector}.lfm-popup-deferred`).forEach((root) => {
      root.classList.remove('lfm-popup-deferred');
      root.removeAttribute('aria-hidden');
      root.removeAttribute('inert');
      document.body.style.overflow = 'hidden';
    });
  };

  function revealAfterIntent() {
    if (window.scrollY >= Math.max(640, window.innerHeight * 0.8)) {
      revealDeferredPopup();
    }
  }

  const dismissPopup = () => {
    document.querySelectorAll(popupRootSelector).forEach((root) => {
      root.classList.add('lfm-popup-suppressed');
      root.setAttribute('aria-hidden', 'true');
      root.setAttribute('inert', '');
      const closeButton = root.querySelector(popupCloseSelector);
      if (closeButton && root.dataset.lfmDismissed !== 'true') {
        root.dataset.lfmDismissed = 'true';
        closeButton.click();
      }
    });
  };

  window.lfmDismissEmailPopup = dismissPopup;

  const managePopupVisibility = () => {
    document.querySelectorAll(popupRootSelector).forEach((root) => {
      if (!isHomepage || document.body.classList.contains('lfm-cart-open')) {
        dismissPopup();
        releasePageScroll();
        return;
      }

      if (!popupEligible) {
        root.classList.add('lfm-popup-deferred');
        root.setAttribute('aria-hidden', 'true');
        root.setAttribute('inert', '');
        releasePageScroll();
        return;
      }

      root.classList.remove('lfm-popup-deferred', 'lfm-popup-suppressed');
      root.removeAttribute('aria-hidden');
      root.removeAttribute('inert');
    });
  };

  const updatePopupCopy = () => {
    updateQueued = false;

    document.querySelectorAll('.pp-modal .ecomsend__Modal__CustomDialog').forEach((dialog) => {
      const title = dialog.querySelector('.ecomsend__Modal__TitleText');
      const description = dialog.querySelector('.ecomsend__Modal__TitleHelpText');

      dialog.querySelectorAll('#first_name, #last_name').forEach((input) => {
        input.removeAttribute('required');
        input.setAttribute('aria-hidden', 'true');
        input.setAttribute('tabindex', '-1');
      });

      if (title?.textContent.trim() === popupTitle && description) {
        if (description.textContent.trim() !== popupCopy) {
          description.textContent = popupCopy;
        }
      }
    });

    document.querySelectorAll('.ecomsend__Popover__Widget__Text').forEach((widgetText) => {
      if (widgetText.textContent.trim() !== popupWidgetCopy && /GET\s+\d+\s*%\s*OFF/i.test(widgetText.textContent.trim())) {
        widgetText.textContent = popupWidgetCopy;
      }
    });

    managePopupVisibility();
  };

  const queuePopupUpdate = () => {
    if (updateQueued) return;
    updateQueued = true;
    queueMicrotask(updatePopupCopy);
  };

  const start = () => {
    const popupObserver = new MutationObserver(queuePopupUpdate);
    popupObserver.observe(document.body, {
      childList: true,
      subtree: true,
    });

    if (isHomepage) {
      window.addEventListener('scroll', revealAfterIntent, { passive: true });
          window.setTimeout(revealDeferredPopup, 0);
    }

    updatePopupCopy();
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start, { once: true });
  } else {
    start();
  }
})();
